import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { MenuHeader, Button, MobileFilterContext } from '../../components'

const MobileFilterPanel = ({ title, filterKey, children }) => {
  const { active } = useContext(MobileFilterContext)

  if ( active === filterKey ) {
    return (
      <MobileFilterContext.Consumer>
        {({ setActivePanel }) => (
          <div className="fixed left-0 top-0 h-screen w-full bg-white overflow-y-auto pb-10" style={{zIndex: 901}}>
            <MenuHeader
              className="bg-white z-10 fixed top-0 left-0 w-full"
              title={title}
              onClose={() => setActivePanel('')}
            />
            <div className="p-5 pt-24">
              { children }
            </div>
            <div className="w-full fixed bottom-0">
            <Button
              onClick={() => setActivePanel('')}
              style={{borderRadius: 0}}
            >
              Terapkan
            </Button>
          </div>
          </div>
        )}
      </MobileFilterContext.Consumer>
    )
  }

  return null
}

MobileFilterPanel.propTypes = {
  title: PropTypes.string.isRequired,
  filterKey: PropTypes.string.isRequired
}

export { MobileFilterPanel }
